// extracted by mini-css-extract-plugin
module.exports = {"workLog-section":"WorkLog_workLog-section__i6fXY","workLog-cards":"WorkLog_workLog-cards__8LoiU"};